
import Actions from './actions';
import PropTypes from 'prop-types';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import SelectControl from '../../../components/form/select-control.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../components/form/text-control.jsx';
import {Link} from 'react-router-dom';
import { Recaptcha } from '../../../components';
import { handleLocalStateChange } from '../../../utils/react';
import { PlanSelectOptions } from '../../../../client/helpers/plan-options';

const propTypes = {
  linkInputState: PropTypes.func,
  plan_id: PropTypes.string,
  loading: PropTypes.bool,
  state: PropTypes.object,
};

class Form extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();
    this.state.plan_id = this.props.plan_id || 0;
  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

    if (this.input.email) {
      this.input.email.focus();
    }
  }

  componentWillUnmount() {
    this.unsubscribeStore();
    Actions.resetStore();
  }

  onStoreChange() {

    this.setState(Store.getState());
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.input.plan.value() === '') {
      return;
    }

    const planId = Number(this.input.plan.value());

    Actions.doSignup({
      name: this.input.name.value(),
      username: this.input.email.value(),
      password: this.input.password.value(),
      email: this.input.email.value(),
      privacy: this.input.privacy.input.checked,
      newsletter: this.state.newsletter,
      plan_id: planId,
      captcha: this.state.captcha,
    });

  }

  onPickPlan(e){
    this.setState({plan_id: Number(e.target.value)});
  }

  handleNewsletterChange(e) {
    this.setState({
      newsletter: e.target.checked,
    });
  }

  render() {

    const alerts = [];
    if (this.state.success) {
      alerts.push(
        <div key="success" className="alert alert-success">
          Loading...
        </div>
      );
    }

    if (this.state.validation.error) {
      //hack customized form error messages to be friendly
      const errorTarget = Object.keys(this.state.validation.hasError)[0];
      let errorMessage = this.state.validation.help[errorTarget];
      if (errorMessage){
        if (errorMessage.indexOf("not allowed to be empty")!==-1){
          errorMessage = "This field is required.";
        } else if (errorMessage.indexOf("must be a valid email")!==-1){
          errorMessage = "A valid email address is required.";
        } else if (errorMessage === '"privacy" must be one of [true]'){
          errorMessage = "You must agree to the Terms of Service.";
        } else if (errorMessage === '"captcha" must be a string'){
          errorMessage = "Please click the CAPTCHA box above to prove you are not a robot.";
        }
        this.state.validation.help[errorTarget] = errorMessage; // eslint-disable-line
      }
      alerts.push(
        <div key="danger" className="alert alert-danger">
          {this.state.validation.error}
        </div>
      );
    }

    const env = process.env.CMC_PORTAL_ENV;
    let formElements;
    let captchaForm;

    const planOptions = PlanSelectOptions(this.state.planOptions);

    if (!this.state.success) {
      formElements = <fieldset>
        <TextControl
          ref={(c) => (this.input.email = c)}
          name="email"
          type="email"
          label="Email"
          autocomplete="email"
          hasError={this.state.validation.hasError.email}
          help={this.state.validation.help.email}
          required={true}
          disabled={this.state.loading}
          maxlength="256"
        />
        <TextControl
          ref={(c) => (this.input.name = c)}
          name="name"
          label="Name"
          autocomplete="name"
          autocapitalize="words"
          hasError={this.state.validation.hasError.name}
          help={this.state.validation.help.name}
          disabled={this.state.loading}
          maxlength="194"
        />
        <TextControl
          ref={(c) => (this.input.password = c)}
          name="password"
          label="Password"
          type="password"
          autocomplete="new-password"
          hasError={this.state.validation.hasError.password}
          help={this.state.validation.help.password}
          required={true}
          disabled={this.state.loading}
          maxlength="72"
        />
        <SelectControl value={this.state.plan_id} onChange={this.onPickPlan.bind(this)}
          ref={(c) => (this.input.plan = c)}
          label="Plan"
          required={true}
          disabled={this.props.loading}>
          {planOptions}
        </SelectControl>

        <div className="checkbox-container">
          <label htmlFor="newsletter">I want to receive updates from the Pro API newsletter</label>
          <TextControl
            ref={(c) => (this.input.newsletter = c)}
            checked={this.state.newsletter}
            onChange={this.handleNewsletterChange.bind(this)}
            name="newsletter"
            type="checkbox"
            hasError={this.state.validation.hasError.newsletter}
            help={this.state.validation.help.newsletter}
            disabled={this.state.loading}
          />
        </div>

        <div className="checkbox-container">
          <label htmlFor="privacy">I agree to the <a target="_blank" rel="noopener noreferrer" href={this.state.plan_id < 1 ? '/user-agreement-personal/' : '/user-agreement-commercial/'}>{this.state.plan_id < 1 ? 'Personal Terms of Use' : 'Commercial Terms of Use'}</a> and <a href="https://coinmarketcap.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a></label>
          <TextControl
            ref={(c) => (this.input.privacy = c)}
            name="privacy"
            type="checkbox"
            hasError={this.state.validation.hasError.privacy}
            help={this.state.validation.help.privacy}
            required={true}
            disabled={this.state.loading}
          />
        </div>

        <ControlGroup
          hasError={this.state.validation.hasError.captcha}
          help={this.state.validation.help.captcha}
        >
          <Recaptcha
            onChange={handleLocalStateChange.bind(this, 'captcha')}
          />
        </ControlGroup>

        <ControlGroup hideLabel={true} hideHelp={true}>
          <Button
            type="submit"
            inputClasses={{ 'btn-primary': true }}
            disabled={this.state.loading}>
            {env === 'sandbox' ? 'Create my test account' : 'Create my account'}
            <Spinner space="left" show={this.state.loading} />
          </Button>
        </ControlGroup>
      </fieldset>;

    }

    return (
      <section>
        <div className="signup-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
          <h1 className="display-4">Sign Up</h1>
        </div>
        <form className="auth-form" onSubmit={this.handleSubmit.bind(this)} method="post">
          {alerts}
          {formElements}
          {captchaForm}
        </form>
        <div className="row auth-form-tip">
          <p className="text-center">Already have an account? <Link to="/login">Log In.</Link></p>
        </div>
      </section>
    );
  }
}

Form.propTypes = propTypes;

export default Form;



// WEBPACK FOOTER //
// ./client/pages/main/signupAccountAPI/form.jsx